import LanguageDetector from '@bfe/by-i18n-language-detect';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { BYBIT_LANG_KEY, supportLanguages } from '@/utils/constants';
import { DEFAULT_LANG } from '@/utils/constants/common';
import isApp from '@/utils/ua';

import { i18nCache, i18nUrl } from './url';

// const LanguageDetector = window.ByI18nLanguageDetector;

// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const DEFAULT_LOAD_PATH =
  'https://tms.ffe390afd658c19dcbf707e0597b846d.de/download/trade/{{ns}}/{{lng}}/';
//TODO: en-US -> en
// if (localStorage.BYBIT_LANG_KEY === 'en-US') {
//   // 处理用户浏览器的BYBIT_LANG_KEY值
//   localStorage.setItem('BYBIT_LANG_KEY', 'en');
// } else
if (localStorage.BYBIT_LANG_KEY === 'zh-CN') {
  localStorage.setItem('BYBIT_LANG_KEY', 'zh-MY');
}

let routeLang = '';
const defaultLanguage = DEFAULT_LANG;

if (isApp()) {
  // 如果是app跳转，获取app端传过来的语言参数
  let lang =
    localStorage.getItem('BYBIT_LANG_KEY') ||
    location.search.substring(location.search.indexOf('=') + 1) ||
    defaultLanguage;
  if (
    ['/notifications', '/user-feedback', '/unsubscribe'].some(
      (item) => location.pathname.indexOf(item) > -1,
    )
  ) {
    lang = localStorage.getItem('BYBIT_LANG_KEY') || defaultLanguage;
  }
  routeLang = supportLanguages.includes(lang) ? lang : defaultLanguage;
  localStorage.setItem('BYBIT_LANG_KEY', routeLang);
} else if (localStorage.BYBIT_LANG_KEY) {
  // 当用户设置的语言不被当前页面支持时，修改语言为 en-US，
  // 同时刷新页面保证页面内所有三方模块都应用了新语言
  // 比如 sign-up页面或者hk站点
  if (supportLanguages.indexOf(localStorage.BYBIT_LANG_KEY) < 0) {
    localStorage.setItem('BYBIT_LANG_KEY', defaultLanguage);
    // window.location.reload();
  }
}

let ns = ['inverse', 'inverse-error-code'];
if (window.location.pathname.indexOf('/notifications') > -1) {
  ns = ['notifications'];
} else if (window.location.pathname.indexOf('/user-feedback') > -1) {
  ns = ['user-feedback'];
} else if (window.location.pathname.indexOf('/unsubscribe') > -1) {
  ns = ['unsubscribe'];
}

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    react: {
      useSuspense: false,
    },
    fallbackLng: routeLang,
    // lng: routeLang,
    // nsSeparator: false,
    debug: true,
    // resources: resources(),
    backend: {
      loadPath: i18nUrl || DEFAULT_LOAD_PATH,
    },
    load: 'currentOnly',
    ns: ns,
    defaultNS: 'inverse',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      defaultLanguage,
      cacheKey: BYBIT_LANG_KEY,
      supportLangs: supportLanguages,
    },
  })
  .finally(() => {
    console.info('---- transication  -----');

    i18nCache.i18n = i18n;
  });

export default i18n;
